import React from 'react';

import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';

const NewSelectBox = (props) => {
  const {
    name,
    params = {},
    list = [],
    valueKey = '',
    labelKey = '',
    handleGetValue = (f, newParams, name) => f,
  } = props;

  const handleClick = (value) => {
    let newParams = params;
    newParams = {
      ...newParams,
      [name]: value,
    };
    handleGetValue(newParams, name);
  };

  return (
    <MenuList>
      {list.map((option, index) => (
        <MenuItem
          index={index}
          key={option[valueKey]}
          onClick={() => handleClick(option[valueKey])}
          disableRipple
        >
          {option[labelKey]}
        </MenuItem>
      ))}
    </MenuList>
  );
};
export default NewSelectBox;
